import { orderBy, unionBy } from 'helpers/lodash'
import { onConnect } from 'utils/socket'

import * as actionTypes from '../actionTypes/WebSocket'
import { updateObject } from '../utility'

const initialState = {
    chatMsg: null,
    chatMessages: [],
    ttmMsg: null,
    roomStateMsg: null,
    socket: null,
    msg: null,
    audioMsg: null,
    noteMsg: [],
    isIframeShared: false,
    iframeShareUrl: { teacher_url: '', student_url: '' },
    userId: '',
    whiteboardUrl: '',
}

const receiveAllMessage = (state, action) => {
    return updateObject(state, {
        msg: action.msg,
    })
}

const receiveChatMessage = (state, action) => {
    return updateObject(state, {
        chatMsg: action.chatMsg, // TO-DO needs to be refactored
        chatMessages: [...state.chatMessages, action.chatMsg],
    })
}

const receiveRoomStateMessage = (state, action) => {
    return updateObject(state, {
        roomStateMsg: action.roomStateMsg,
    })
}

const receiveTtmMessage = (state, action) => {
    return updateObject(state, {
        ttmMsg: action.ttmMsg,
    })
}

const receiveAudioMessage = (state, action) => {
    return updateObject(state, {
        audioMsg: action.audioMsg,
    })
}

const receiveNoteMessage = (state, action) => {
    return updateObject(state, {
        noteMsg: [action.noteMsg, ...state.noteMsg],
    })
}

const deleteNoteMessage = (state, action) => {
    const deletedNoteMsgIndex = state.noteMsg.findIndex(
        item => item.note.id === action.noteMsg.note.id
    )

    if (deletedNoteMsgIndex > -1) {
        const existingMessage = state.noteMsg[deletedNoteMsgIndex]

        const modifiedMessage = {
            ...existingMessage,
            note: {
                ...existingMessage.note,
                isDeleted: true,
            },
        }

        return updateObject(state, {
            noteMsg: [
                ...state.noteMsg.slice(0, deletedNoteMsgIndex),
                modifiedMessage,
                ...state.noteMsg.slice(deletedNoteMsgIndex + 1),
            ],
        })
    }

    return state
}

const fetchNotesMessages = (state, action) => {
    return updateObject(state, {
        noteMsg: orderBy(
            unionBy(action.notesMessages, state.noteMsg, 'note.id'),
            'note.id',
            'desc'
        ),
    })
}

const populateDummyNotesMessages = (state, action) => {
    return updateObject(state, {
        noteMsg: [...state.noteMsg, ...action.notesMessages],
    })
}

const setSenderIdForDummyNotes = (state, action) => {
    return updateObject(state, {
        userId: action.userId,
    })
}

const setSocket = (state, action) => {
    return updateObject(state, {
        socket: action.socket,
    })
}

const setIsIframeShared = (state, action) => {
    return updateObject(state, {
        isIframeShared: action.data.isShared,
        iframeShareUrl: action.data.urlData,
    })
}

const resetState = () => initialState

const resetGeneralMessages = state => {
    return updateObject(state, {
        msg: null,
    })
}

const WebSocketReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SET_ALL_MSG:
            return receiveAllMessage(state, action)
        case actionTypes.SET_CHAT_MSG:
            return receiveChatMessage(state, action)
        case actionTypes.SET_ROOM_STATE_MSG:
            return receiveRoomStateMessage(state, action)
        case actionTypes.SET_TTM_MSG:
            return receiveTtmMessage(state, action)
        case actionTypes.SET_AUDIO_MESSAGE:
            return receiveAudioMessage(state, action)
        case actionTypes.SET_NOTE_MESSAGE:
            return receiveNoteMessage(state, action)
        case actionTypes.DELETE_NOTE_MESSAGE:
            return deleteNoteMessage(state, action)
        case actionTypes.FETCH_NOTES_MESSAGES:
            return fetchNotesMessages(state, action)
        case actionTypes.POPULATE_DUMMY_NOTES_MESSAGES:
            return populateDummyNotesMessages(state, action)
        case actionTypes.SET_SENDER_ID_FOR_DUMMY_NOTES:
            return setSenderIdForDummyNotes(state, action)
        case actionTypes.SET_SOCKET:
            return setSocket(state, action)
        case actionTypes.RESET_GENERAL_MESSAGES:
            return resetGeneralMessages(state)
        case actionTypes.RESET_WEB_SOCKET_STATE:
            return resetState()
        case actionTypes.SET_IS_IFRAME_SHARED:
            return setIsIframeShared(state, action)
        default:
            return state
    }
}

export default WebSocketReducer
